import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import TrainPanel from "@/components/TrainPanel";
import { PageHead } from "@/components/Kit";
import { fetchTiers } from "@/lib/api";
import { readyText, useTitle } from "@/lib/brand";

/**
 * TRAIN — 2026-10-27. The same TrainPanel as the home page's Train section, on its own page,
 * with every tier shown up front (Dog 10-26: full transparency — the price and what it buys,
 * before anyone types a word).
 */
export default function TrainPage() {
  useTitle("Train an Expert");
  const [tiers, setTiers] = useState([]);
  useEffect(() => { fetchTiers().then((d) => setTiers(d?.tiers || [])).catch(() => {}); }, []);
  return (
    <main data-testid="train-page" className="ex-page">
      <div className="ex-wrap pb-28">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.1fr]">
          <div>
            <PageHead
              eyebrow="Train an Expert"
              title="Name a subject. Get a specialist."
              lede="We find the best sources on it, check every fact on its own, train the Expert for your phone's Engine and test it before it reaches you. You'll see every stage as it happens."
            />
            {tiers.length > 0 && (
              <div className="space-y-3">
                {tiers.map((t) => (
                  <div key={t.scope} className={`ex-card p-5 ${t.available ? "" : "opacity-50"}`}>
                    <div className="flex items-baseline justify-between gap-4">
                      <span className="text-white font-medium">{t.label}</span>
                      <span className="text-white">{t.available ? t.price_text : "Coming soon"}</span>
                    </div>
                    <div className="ex-small mt-1">{t.contains}</div>
                    {(t.includes || []).length > 0 && (
                      <ul className="mt-4 space-y-2">
                        {t.includes.map((line) => (
                          <li key={line} className="flex gap-2.5 ex-small">
                            <Check className="h-4 w-4 flex-none mt-[3px] text-white" strokeWidth={2} /> <span>{line}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                    {t.available && t.ready_in_minutes > 0 && <div className="ex-tiny mt-2">Ready in {readyText(t.ready_in_minutes).toLowerCase()} if started now</div>}
                  </div>
                ))}
                <p className="ex-tiny pt-2">Every tier gets the same fact checks and is tested on your Engine. The higher tiers read more sources and are examined longer. One payment; no subscription.</p>
              </div>
            )}
          </div>
          <div className="lg:pt-24"><TrainPanel /></div>
        </div>
      </div>
    </main>
  );
}
